export const lightTheme = {
  // light default colors
  // primary: '#6699cc',

  focus: '#0d0d0d0f',
  active: '#0d0d0d33',
  // primary colors
  primary30: '#004a99',
  primary40: '#0063cc',
  primary50: '#007bff',
  primary60: '#3396ff',
  primary70: '#66b0ff',
  'primary-focus': '#0d0d0d33',

  link40: '#749db7',
  link50: '#3087c1',
  link60: '#24506d',

  red40: '#d88484',
  red50: '#993636',
  red60: '#511818',

  // secondary colors

  // light
  secondary40: '#e55438',
  secondary50: '#c1391e',
  secondary60: '#ba2902',

  // // dark
  // secondary40: '#e06244',
  // secondary50: '#d34220',
  // secondary60: '#cc3300',

  // danger colors

  // light
  danger40: '#EA5757',
  danger50: '#E02B2B',
  danger60: '#910F0F',

  // dark
  // danger40: '#F96662',
  // danger50: '#E2322D',
  // danger60: '#AD1F1F',

  // old
  // danger50: '#eb5545',

  // dark colors

  // light
  dark40: '#686868',
  dark50: '#515151',
  dark60: '#3D3D3D',
  dark70: '#171717',

  // dark
  // dark40: '#686868',
  // dark50: '#4F4F4F',
  // dark60: '#282828',

  // success colors

  // light
  success40: '#147a5a',
  success50: '#105642',
  success60: '#0b3d2d',

  // dark
  // success40: '#1a8e6a',
  // success50: '#136650',
  // success60: '#0c4433',

  // apple light colors
  blue: '#007AFF',
  green: '#34C759',
  indigo: '#5856D6',
  orange: '#FF9500',
  pink: '#FF2D55',
  purple: '#AF52DE',
  red: '#FF3B30',
  teal: '#5AC8FA',
  yellow: '#FFCC00',
  gray1: '#8E8E93',
  gray2: '#AEAEB2',
  gray3: '#C7C7CC',
  gray4: '#D1D1D6',
  gray5: '#E5E5EA',
  gray6: '#F2F2F7',

  'gh-text': '#191919',
  'gh-text-secondary': '#707070',
  'gh-border': '#cccccc',
  'gh-bg0': '#e8e8e8',
  'gh-bg1': '#efefef',

  // global vars
  'border-color': '#000',

  bar: '#e9e9e9',
  bartext: '#111111',
  body: '#F2F2F2',
  dialog: '#E9E9E9',
  text: '#202020',
  inversetext: '#F2F2F2',
  graythumb: '#808080',
  redthumb: '#e3342f',
  marklabelia: '#7a7a7a',
  inverse: '#212121',
  light: '#545454',
  whiteformlight: '#9e9e9e',
  scrollbarbgcolor: '#f5f5f5',
  scrollbarborder: '2px solid #d4d1d1',
  scrollbartrackbgcolor: 'rgb(180 180 180)',
  bottomnavbgcolor: '#eeeeee',
  textsecondary: 'rgba(0, 0, 0, 0.54)',
  bottomborder: 'black 1px solid',
  barshadow:
    '0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 10%), 0px 0px 0px 0px rgb(0 0 0 / 0%)',
  logoimg: 'url(/imgs/assets/white-logo-512.svg)',
  gitimg: 'url(/imgs/assets/devops/github-logo-black.svg)',
  imgborder: 'black 1px solid',
  menubackground: '#f1f1f1',
  chatboxbackground: '#d9e9f9',
  menutextcolor: '#545454',
  globalbackground: '#ffffff',
  npmbackground: '#ffffff',
  gitbackground: '#ffffff',
  npmopacity: '0.6',
  gitopacity: '0.6',
  gitshadow:
    'rgb(22 21 22) 0px 0px 5px 0px, rgb(22 21 22) 0px 0px 0px 0px, rgb(22 21 22) 0px 0px 0px 0px',
  gitshadowhover:
    'rgb(22 21 22) 0px 0px 10px 0px, rgb(22 21 22) 0px 0px 0px 0px, rgb(22 21 22) 0px 0px 0px 0px',
  gitborder: '1px solid rgb(0 0 0 / 49%)',
  gitborderhover: '1px solid rgb(0 0 0 / 69%)',
  dbcbackground: '#f0f0f0',
  dbcshadow:
    'rgb(13 95 19) 0px 0px 15px 0px, rgb(26 95 13) 0px 0px 0px 0px, rgb(14 95 13) 0px 0px 0px 0px',
  dbcborder: '1px solid rgb(0 204 35 / 49%)',
  dbcshadowhover:
    'rgb(97 142 100) 0px 0px 15px 0px, rgb(131 160 126) 0px 0px 0px 0px, rgb(128 156 128) 0px 0px 0px 0px',
  dbcborderhover: '1px solid rgb(0 204 35 / 32%)',
  tagcolor: '#100e8a',
  buttonborder: '#828282 1px solid',
  sidenavbg: '#FFFFFF',
  sidenavhover: '#F5F6F6',
  iconcolor: '#767576',
  borderstyle: '1px solid #c0c1c2',
  divider: '#e9e9e9',
  cardbg: '#e9e9e9',
  cardshadow: '1px 2px 4px 2px rgb(0 0 0 / 10%)',
  hrcolor: '1px solid #00000030',
  cardborder: '0.1em solid #DADADA',
  bordercolor: '#DADADA',

  textfieldcolor: '#ffffff',
  textfieldtextcolor: '#232323',
  textfieldoutlinecolor: '#828282',
  textfieldoutlinecolorhover: '#666666',
  lighttextfieldcolor: '#ffffff',
  lighttextfieldtextcolor: '#232323',
  lighttextfieldoutlinecolor: '#828282',
  lighttextfieldoutlinecolorhover: '#666666',
  buttonbgcolor: '#b53f3f',
  buttonbgcolorhover: '#c15353',
  buttontextcolor: '#ffffff',
  disabledtextcolor: 'rgba(0, 0, 0, 0.26)',
  disabled: 'rgba(0, 0, 0, 0.38)',
  helpretextcolor: 'rgba(0, 0, 0, 0.54)',
  skeleton: 'rgba(0, 0, 0, 0.11)',
  skeletonlight: 'rgba(0,0,0,0.11)',

  tabbarcolor: '#2a2a2a',
  tabbar: '#E9E8E8',
  tabsunderline: '#e3342f',
  tabsbody: '#ffffff',

  stepperpaper: '#DCDCDC',
  steppercolor: '#292929',

  linkcolor: '#3490dc'
}
export const darkTheme = {
  // dark default colors
  // primary: '#0A84FF',
  // primary: '#6699cc',
  // primary: '#448bd2',

  // primary: '#1c4075',
  // secondary: '#FF9F0A',
  // secondary: '#666699',
  focus: '#ffffff0f',
  active: '#ffffff33',

  // primary colors
  primary30: '#0056b3',
  primary40: '#006fe6',
  primary50: '#1a88ff',
  primary60: '#4da3ff',
  primary70: '#80bdff',
  'primary-focus': '#ffffff33',

  link40: '#8dc3eb',
  link50: '#3490dc',
  link60: '#134871',

  red40: '#dd9b9b',
  red50: '#b53f3f',
  red60: '#632121',

  // secondary colors

  // light
  // secondary40: '#e55438',
  // secondary50: '#c1391e',
  // secondary60: '#ba2902',

  // dark
  secondary40: '#e06244',
  secondary50: '#d34220',
  secondary60: '#cc3300',

  // danger colors

  // light
  // danger40: '#EA5757',
  // danger50: '#E02B2B',
  // danger60: '#910F0F',

  // dark
  danger40: '#F96662',
  danger50: '#E2322D',
  danger60: '#AD1F1F',

  // old light
  // danger50: '#eb5545',

  // old dark
  // danger50: '#b53f3f',

  // dark colors

  // light
  // dark40: '#595959',
  // dark50: '#3D3D3D',
  // dark60: '#171717',

  // dark
  dark40: '#282828',
  dark50: '#4F4F4F',
  dark60: '#686868',
  dark70: '#727272',

  // success colors

  // light
  // success40: '#147a5a',
  // success50: '#105642',
  // success60: '#0b3d2d',

  // dark
  success40: '#1a8e6a',
  success50: '#136650',
  success60: '#0c4433',

  // apple dark colors
  blue: '#0A84FF',
  green: '#30D158',
  indigo: '#5E5CE6',
  orange: '#FF9F0A',
  pink: '#FF375F',
  purple: '#BF5AF2',
  red: '#FF453A',
  teal: '#64D2FF',
  yellow: '#FFD60A',
  gray1: '#8E8E93',
  gray2: '#636366',
  gray3: '#48484A',
  gray4: '#3A3A3C',
  gray5: '#2C2C2E',
  gray6: '#1C1C1E',

  'gh-text': '#c9d1d9',
  'gh-text-secondary': '#8b949e',

  'gh-border': '#30363d',
  'gh-bg0': '#161b22',
  'gh-bg1': '#0d1117',
  // global vars
  'border-color': '#fff',

  bar: '#161616',
  bartext: '#eeeeee',
  body: '#0d0d0d',
  dialog: '#161616',
  text: '#F2F2F2',
  inversetext: '#202020',
  marklabelia: '#7a7a7a',
  graythumb: '#808080',
  redthumb: '#e3342f',
  inverse: '#212121',
  whiteform: '#545454',
  whiteformlight: '#9e9e9e',
  scrollbarbgcolor: '#111',
  scrollbarborder: '2px solid #202020',
  scrollbartrackbgcolor: 'rgb(60 60 60)',
  bottomnavbgcolor: '#111111',
  textsecondary: 'rgba(225,225,225,0.54)',
  bottomborder: '#F2F2F2 1px solid',
  barshadow:
    '0px 0px 0px 0px rgb(255 255 255 / 20%), 0px 1px 1px 0px rgb(255 255 255 / 10%), 0px 0px 0px 0px rgb(255 255 255 / 0%)',
  logoimg: 'url(/imgs/assets/black-logo-512.svg)',
  gitimg: 'url(/imgs/assets/devops/github-logo-white.svg)',
  imgborder: 'white 1px solid',
  menubackground: '#0e0e0e',
  chatboxbackground: '#091929',
  menutextcolor: '#ababab',
  globalbackground: 'rgb(0 0 0)',
  npmbackground: 'rgb(0 0 0)',
  gitbackground: 'rgb(0 0 0)',
  npmopacity: '0.5',
  gitopacity: '0.5',
  gitshadow:
    'rgb(93 88 88) 0px 0px 10px 0px, rgb(93 88 88) 0px 0px 0px 0px, rgb(93 88 88) 0px 0px 0px 0px',
  gitshadowhover:
    'rgb(93 88 88) 0px 0px 15px 0px, rgb(93 88 88) 0px 0px 0px 0px, rgb(93 88 88) 0px 0px 0px 0px;',
  gitborder: '1px solid rgb(255 255 255 / 49%)',
  gitborderhover: '1px solid rgb(255 255 255 / 69%)',
  dbcbackground: '#0f0f0f',
  dbcshadow:
    'rgb(13 95 19) 0px 0px 15px 0px, rgb(26 95 13) 0px 0px 0px 0px, rgb(14 95 13) 0px 0px 0px 0px',
  dbcborder: '1px solid rgb(0 204 35 / 49%)',
  dbcshadowhover:
    'rgb(97 142 100) 0px 0px 15px 0px, rgb(131 160 126) 0px 0px 0px 0px, rgb(128 156 128) 0px 0px 0px 0px',
  dbcborderhover: '1px solid rgb(0 204 35 / 32%)',
  tagcolor: '#fbff00',
  buttonborder: '#d8d8d8 1px solid',
  sidenavbg: '#2B2B2B',
  sidenavhover: '#111111',
  iconcolor: '#E5E5E5',
  borderstyle: '1px solid #3f3e3d',
  divider: '#161616',
  cardbg: '#161616',
  cardshadow: '1px 2px 4px 2px rgb(138 138 138 / 10%)',
  hrcolor: '1px solid #ffffff30',
  cardborder: '0.1em solid #252525',
  bordercolor: '#252525',

  textfieldcolor: '#ffffff',
  textfieldtextcolor: '#E5E5E5',
  textfieldoutlinecolor: '#d8d8d8',
  textfieldoutlinecolorhover: '#939393',
  lighttextfieldcolor: '#ffffff',
  lighttextfieldtextcolor: '#232323',
  lighttextfieldoutlinecolor: '#828282',
  lighttextfieldoutlinecolorhover: '#666666',
  buttonbgcolor: '#b53f3f',
  buttonbgcolorhover: '#c15353',
  buttontextcolor: '#ffffff',
  disabledtextcolor: 'rgba(255, 255, 255, 0.26)',
  disabled: 'rgba(255, 255, 255, 0.38)',
  helpretextcolor: 'rgba(255, 255, 255, 0.54)',
  skeleton: 'rgb(255 255 255 / 11%)',
  skeletonlight: 'rgba(0,0,0,0.11)',

  tabbarcolor: '#d6d6d6',
  tabbar: '#171717',
  tabsunderline: '#e3342f',
  tabsbody: '#1b1b1b',

  stepperpaper: '#232323',
  steppercolor: '#d6d6d6',

  linkcolor: '#3490dc'

  // switchthumb: '',
  // switchtrack
}
